import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_1839_2418)" }, [
      _createElementVNode("path", {
        d: "M8 0C3.58887 0 0 3.58887 0 8C0 12.4111 3.58887 16 8 16C12.4111 16 16 12.4111 16 8C16 3.58887 12.4111 0 8 0ZM8 15C4.14013 15 1 11.8599 1 8C1 4.14013 4.14013 1 8 1C11.8599 1 15 4.14013 15 8C15 11.8599 11.8599 15 8 15ZM11.3535 7.6465C11.5489 7.84188 11.5489 8.15825 11.3535 8.3535L8.8535 10.8535C8.75588 10.9511 8.62788 11 8.5 11C8.37212 11 8.24412 10.9511 8.1465 10.8535C7.95112 10.6581 7.95112 10.3417 8.1465 10.1465L9.793 8.5H5C4.72388 8.5 4.5 8.27637 4.5 8C4.5 7.72363 4.72388 7.5 5 7.5H9.793L8.1465 5.8535C7.95112 5.65812 7.95112 5.34175 8.1465 5.1465C8.34188 4.95125 8.65825 4.95113 8.8535 5.1465L11.3535 7.6465Z",
        fill: "#00FF4B"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_1839_2418" }, [
        _createElementVNode("rect", {
          width: "16",
          height: "16",
          fill: "white"
        })
      ])
    ], -1)
  ])))
}